import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
} from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";

import "./index.css";

import { basePath, tokenKeyName } from "./config";
import handleApiError from "./helpers/handleApiError";

const queryCache = new QueryCache({
  onError: (error, query) => {
    if (query.meta?.disabledGlobalToast || error?.code === "ECONNABORTED") {
      return;
    }

    if (query.meta?.history) {
      handleApiError(error, query.meta.history);
      return;
    }

    if (axios.isAxiosError(error) && error.response?.status === 401) {
      localStorage.removeItem(tokenKeyName);
      toast.error("401 Unauthorized. Please try signing in again.");
      return;
    }

    if (axios.isAxiosError(error) && error.response?.status === 500) {
      toast.error("500 Internal Server Error");
      return;
    }

    if (axios.isAxiosError(error) && error.response?.status === 404) {
      toast.error("404 Not Found");
      return;
    }

    if (
      axios.isAxiosError(error) &&
      error.response?.status >= 401 &&
      error.response?.status < 500
    ) {
      const erroMessage =
        error.response?.data?.message ||
        error?.message ||
        error?.response?.data ||
        "Unexpected error";

      toast.error(`${error?.status} - ${erroMessage}`);
      return;
    }
  },
});

// Create a client
const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // refetchOnMount: false,
      cacheTime: 3 * 60 * 1000, // Cache for 3 minutes, Default is 5 minutes
    },
  },
});

ReactDOM.render(
  <BrowserRouter basename={basePath}>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools />
    </QueryClientProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
